export const WarningIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none">
      <path
        fill="url(#a)"
        d="M12.134 1a1 1 0 0 1 1.732 0l9.526 16.5a1 1 0 0 1-.866 1.5H3.474a1 1 0 0 1-.866-1.5L12.134 1Z"
      />
      <path
        fill="#fff"
        d="m13.899 5.5-.174 7.685h-1.493L12.05 5.5h1.848ZM12 15.542c0-.274.087-.504.26-.688.18-.19.426-.285.74-.285.31 0 .553.095.732.285a.951.951 0 0 1 .268.688c0 .265-.09.492-.268.681-.179.185-.423.277-.732.277-.314 0-.56-.092-.74-.277a.972.972 0 0 1-.26-.68Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="13"
          x2="13"
          y1="-1.329"
          y2="28.883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE072" />
          <stop offset="1" stopColor="#FFC700" />
        </linearGradient>
      </defs>
    </svg>
  );
};
